import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { Section, Divider, H2, DataField, P } from "./common-components";
import { ARBillingOptions, pharmacyLocationOptions } from "../../patient/clinical-services/service-steps/education/data";
import { GetDropDownValue } from "./data";
import { getTreatmentDrugs } from "../../patient/clinical-services/service-steps/treatment/data";
import { calculateAgeYear } from "../../../helpers/functions";
import { AlertConfirmationTypes } from "../../../helpers/constant";

export const BillingInformation = ({ documentation, treatment, formType }) => {
  const { patient, preAssessment } = useContext(FormContextMA);
  
  // Check if this is the special circumstance: age < 2 and service ended after consent
  const isSpecialCircumstance = 
    patient?.dateOfBirth && 
    calculateAgeYear(patient.dateOfBirth) < 2 &&
    preAssessment?.ageAlertConfirmationType === AlertConfirmationTypes.EndService;

  const billingOptions = {};
  ARBillingOptions.forEach((o) => {
    const optionLabel = String(o?.label ?? "");
    let s = optionLabel.split("PIN");
    let label = s?.[0] || "";
    let pin = s?.[1] || "";
    label = label.toLowerCase().replace("prescription", "Rx");
    label = label.charAt(0).toUpperCase() + label.slice(1);
    billingOptions[o.value] = { label: label.trim(), pin: pin.trim() };
  });

  // const getTreatmentDrugs = () => {
  //   const prescriptions = [
  //     treatment?.firstLineTherapyPrescriptions,
  //     treatment?.stepUpTherapyPrescriptions,
  //     treatment?.alternativeFirstLineTherapyPrescriptions,
  //     treatment?.addOnTherapyOralDecongestantsPrescriptions,
  //     treatment?.addOnTherapyIntranasalDecongestantsPrescriptions,
  //     treatment?.addOnTherapyOralAntihistaminesPrescriptions,
  //     treatment?.nasalSalineRinsePrescriptions,
  //     treatment?.nasalSalineSprayPrescriptions,
  //     treatment?.nasalLubricantPrescriptions,
  //   ];

  //   let combinedDrugs = prescriptions
  //     .filter((list) => Array.isArray(list) && list.length > 0)
  //     .flat();

  //   if (combinedDrugs.length > 0) {
  //     // combinedDrugs = combinedDrugs.map((x) => ({
  //     //   ...x,
  //     // }));
  //     return combinedDrugs;
  //   }
  //   return [];
  // };

  return (
    <Section className="space-y-[0.0833333in]" formType={formType}>
      <H2>Billing Information</H2>
      {isSpecialCircumstance ? (
        <DataField
          label="Assessment stopped at initiation due to patient age (less than 2 years). The session ended immediately after consent obtained and no clinical assessment or billing was completed."
        />
      ) : (
        <>
          <div className="grid grid-cols-2">
            <DataField
              value={
                String(
                  GetDropDownValue(
                    ARBillingOptions,
                    documentation?.billingInformation
                  ) ?? ""
                ).split("PIN")[0]
              }
            />
            <DataField
              label="PIN"
              value={
                String(
                  GetDropDownValue(
                    ARBillingOptions,
                    documentation?.billingInformation
                  ) ?? ""
                ).split("PIN")[1]
              }
            />
          </div>
          <DataField
            className={"!text-teal-300"}
            label="The Pharmacist billing for the Minor Ailment Service is responsible for ensuring the accuracy of the PIN generated by healthcompassRX."
          />
          <Divider />
          <DataField label="May Fill Prescription at Pharmacy of Choice" />
          <div className="grid grid-cols-2">
            {getTreatmentDrugs(treatment)?.map((d) => (
              <>
                <DataField value={d?.medicationName} />
                <DataField value={`Fill Prescription at ${GetDropDownValue(pharmacyLocationOptions, d?.pharmacyLocation)}`} />
              </>
            ))}
          </div>
        </>
      )}
    </Section>
  );
};
